import React from 'react';
import { Hidden, Box, Divider, makeStyles } from '@material-ui/core';

const useDividerStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    border: '1px solid #cfdae2',
    backgroundColor: '#cfdae2',
    [theme.breakpoints.down('sm')]: {
      marginBottom: 8,
      marginTop: 8,
    },
  },
}));

const CustomDivider = () => {
  const classes = useDividerStyles();
  return (
    <Divider
      classes={{
        root: classes.root,
      }}
    />
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 24,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  logoContainer: {
    backgroundColor: '#FFFFFF',
    border: '3px solid #cfdae2',
    width: 64,
    height: 64,
    borderRadius: '50%',
    [theme.breakpoints.down('xs')]: {
      marginTop: -32,
    },
  },
}));

export default function TypeOfInsurance({ insuranceLogo, insuranceTitle }) {
  const classes = useStyles();
  return (
    <Box classes={{ root: classes.container }}>
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        classes={{
          root: classes.logoContainer,
        }}>
        <img
          src={insuranceLogo}
          alt=''
          style={{ width: '60%', fill: '#cfdae2' }}
        />
      </Box>
      <Hidden xsDown>
        <Box display='flex' flexGrow={1}>
          <CustomDivider />
        </Box>
      </Hidden>
      <Box style={{ color: '#004987' }} pl={2} pr={2} mb={{ xs: 3, sm: 0 }}>
        <span dangerouslySetInnerHTML={{ __html: insuranceTitle }}></span>
      </Box>
      <Hidden xsDown>
        <Box display='flex' flexGrow={1} width={{ xs: '100%', sm: '' }}>
          <CustomDivider />
        </Box>
      </Hidden>
    </Box>
  );
}
